import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiPoker } from '../../../Components/Layout/ObavijestiPoker.jsx'



export class PokerClassicMini extends React.Component {


    constructor(props) {
        super(props);
        this.state = { tabs: ['Informacije', 'Raspored'], selectedTab: null }

        this.gotoTab = this.gotoTab.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Poker uživo', 'Poker classic mini', 'poker');
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.gotoTab('Informacije');
    }
    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    render() {
        return <div>
            <Switch>
                <Route render={(route) => <div>
                    <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText='Poker classic mini' headerBackUrl={'/poker/live'}></Header>
                </div>
                } />
            </Switch>

            <div className="white-background">
                <div className="poker-classic-mini-background">
                    <div className='poker-classic-mini-logo'></div>
                </div>

                <div className="poker-container-wider ">
                    <div className="margin-top-small padding-sides-medium-2">
                        {/* <h3 style={{ marginTop: "-10px" }} >LIPANJ 2018</h3> */}

                        Casino SuperSport Stenjevec organizira poker turnir sa garantiranim nagradnim fondom od <b>1.327,23 € GTD</b>.

                        </div>
                    <div className="segment v2 margin-top-small padding-sides-medium-2">
                        {this.state.tabs && this.state.tabs.map((tab) =>
                            <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                        )}
                    </div>


                    {this.state.selectedTab == 'Informacije' &&
                        <div className="padding-sides-medium-2">
                            <div>
                                <h3 className="v1">Informacije</h3>
                                <b>30.05.2019. u 19:00 sati</b> - Igrači koji se prijave na turnir prije 19:00 sati imaju pravo na <b>dodatnih 5000 žetona</b> samo prilikom prve uplate.
                                    <br /> <br />

                                {/* SuperSport Poker Classic Mini:
                                    <br />
                                    <b>08.06.18.</b>  u 19:00 sati -<b>Dan 1A</b> - ulog: 230+20 Kn <br />
                                    <b>09.06.18.</b>  u 18:00 sati -<b>Dan 1B </b>- ulog: 230+20 Kn <br />
                                    <b>10.06.18.</b>  u 16:00 sati -<b>Dan 2</b> – ulog: 230+20 Kn  <br />
                                    <br /> */}


                                {/* Dan 1A i dan 1B se igraju do kraja levela 10. Dan 2 nastavljaju svi igrači koji su završili dan 1A ili 1B te igrači koji su izvršili uplatu do kraja 2. levela Dana 2. Blindovi sa kojima nastavljamo Dan 2 su 600/1200 tj. Level 11 ukoliko se ne pokaže potreba da se vrate leveli ovisno o prosjeku žetona u igri po igraču.  <br /><br /> */}
                                <h3 className="v1 margin-top">Format turnira</h3>
                                <ul className="normal-list">
                                    <li>	Turnir je 8max (8 ljudi po stolu) unlimited re-entry (neograničen broj upada) No Limit Texas Holdem poker</li>
                                    <li>	Kasna registracija i ponovni upad traje do kraja desetog (10) levela</li>
                                    <li>	Ponovni upad je 26,54 + 2,65 €</li>
                                    <li>	Početni broj "stack" je 20 000 turnirskih žetona</li>
                                    <li>	Leveli traju 20 minuta</li>
                                </ul>

                                <br />
                                {/*Kvalificirajte se <b>besplatno</b> za ulaznicu na SuperSport Classic Mini putem <a style={{ color: '#2d373e', textDecoration: 'underline', fontWeight: 'bold' }} href='poker/bonuses/ssopl'>SSOPL turnira</a>.*/}
                                {/* <br /><br />
                                    Potražite Freeroll turnire u Poker aplikaciji pod nazivom turnira <b>‘’Opening Event Freeroll’’</b>!
                                    Prva 3 igrača na svakom Freeroll-u osvajaju besplatan ulaz na turnir uživo u iznosu od <b>300kn</b>! */}

                                <br />
                                <br />
                                <hr></hr>
                            </div>
                        </div>
                    }


                    {this.state.selectedTab == 'Raspored' &&
                        <div className="margin-top">
                            <h3 className="v1 padding-sides-medium-2">SUPERSPORT OPENING EVENT BLINDS SCHEDULE 15MIN</h3>
                            {/* <h3 className="v2 padding-sides-medium-2">08. lipnja 2018 - 10. lipnja 2018</h3> */}
                            <table className="table-1 v2 v3">
                                <thead>
                                    <tr>
                                        <th className="text-left text text-6">Level</th>
                                        <th className=" text-left text text-6">Trajanje</th>
                                        <th className=" text-center text text-6">SB</th>
                                        <th className=" text-center text text-6">BB</th>
                                        <th className=" text-left text text-6">Ante</th>
                                        {/* <th className="text-left text text-6">Start</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            1
                                            </td>
                                        <td className=" text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">50</td>
                                        <td className="text text-1 text-bold text-center">100</td>
                                        <td className="text text-1">100</td>

                                        {/* <td className="text-left text text-1">18:00</td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            2
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">75</td>
                                        <td className="text text-1 text-bold text-center">150</td>
                                        <td className="text text-1">150</td>

                                        {/* <td className="text-left  text text-1">18:30</td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            3
                                            </td>
                                        <td className=" text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">100</td>
                                        <td className="text text-1 text-bold text-center">200</td>
                                        <td className="text text-1">200</td>

                                        {/* <td className="text-left  text text-1">19:00</td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            4
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">150</td>
                                        <td className="text text-1 text-bold text-center">300</td>
                                        <td className="text text-1">300</td>
                                        {/* <td className="text-left  text text-1">19:30</td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            5
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">200</td>
                                        <td className="text text-1 text-bold text-center">400</td>
                                        <td className="text text-1">400</td>

                                        {/* <td className="text-left text text-1">20:20</td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold">
                                            Pauza
                                            </td>
                                        <td className="text text-1">
                                            15:00
                                            </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            6
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">250</td>
                                        <td className="text text-1 text-bold text-center">500</td>
                                        <td className="text text-1">500</td>

                                        {/* <td className="text-left  text text-1">20:50</td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            7
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">300</td>
                                        <td className="text text-1 text-bold text-center">600</td>
                                        <td className="text text-1">600</td>

                                        {/* <td className="text-left  text text-1">21:20</td> */}
                                    </tr>


                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            8
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">400</td>
                                        <td className="text text-1 text-bold text-center">800</td>
                                        <td className="text text-1">800</td>
                                        {/* <td className="text-left  text text-1">22:10</td> */}
                                    </tr>


                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            9
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">500</td>
                                        <td className="text text-1 text-bold text-center">1.000</td>
                                        <td className="text text-1">1.000</td>

                                        {/* <td className="text-left text text-1">22:40</td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            10
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">600</td>
                                        <td className="text text-1 text-bold text-center">1.200</td>
                                        <td className="text text-1">1.200</td>

                                        {/* <td className="text-left  text text-1">23:10</td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold">
                                            Pauza
                                            </td>
                                        <td className="text text-1">
                                            15:00
                                            </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            11
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">800</td>
                                        <td className="text text-1 text-bold text-center">1.600</td>
                                        <td className="text text-1">1.600</td>

                                        {/* <td className="text-left  text text-1">23:40</td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            12
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">1.000</td>
                                        <td className="text text-1 text-bold text-center">2.000</td>
                                        <td className="text text-1">2.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            13
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">1.200</td>
                                        <td className="text text-1 text-bold text-center">2.400</td>
                                        <td className="text text-1">2.400</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>


                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            14
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">1.500</td>
                                        <td className="text text-1 text-bold text-center">3.000</td>
                                        <td className="text text-1">3.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            15
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">1.800</td>
                                        <td className="text text-1 text-bold text-center">3.600</td>
                                        <td className="text text-1">3.600</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            16
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">2.000</td>
                                        <td className="text text-1 text-bold text-center">4.000</td>
                                        <td className="text text-1">4.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold">
                                            Pauza
                                            </td>
                                        <td className="text text-1">
                                            15:00
                                            </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            17
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">2.500</td>
                                        <td className="text text-1 text-bold text-center">5.000</td>
                                        <td className="text text-1">5.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            18
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">3.000</td>
                                        <td className="text text-1 text-bold text-center">6.000</td>
                                        <td className="text text-1">6.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            19
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">4.000</td>
                                        <td className="text text-1 text-bold text-center">8.000</td>
                                        <td className="text text-1">8.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            20
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">5.000</td>
                                        <td className="text text-1 text-bold text-center">10.000</td>
                                        <td className="text text-1">10.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            21
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">6.000</td>
                                        <td className="text text-1 text-bold text-center">12.000</td>
                                        <td className="text text-1">12.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold">
                                            Pauza
                                            </td>
                                        <td className="text text-1">
                                            15:00
                                            </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            22
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">8.000</td>
                                        <td className="text text-1 text-bold text-center">16.000</td>
                                        <td className="text text-1">16.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            23
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">10.000</td>
                                        <td className="text text-1 text-bold text-center">20.000</td>
                                        <td className="text text-1">20.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            24
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">12.000</td>
                                        <td className="text text-1 text-bold text-center">24.000</td>
                                        <td className="text text-1">24.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            25
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">15.000</td>
                                        <td className="text text-1 text-bold text-center">30.000</td>
                                        <td className="text text-1">30.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            26
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">18.000</td>
                                        <td className="text text-1 text-bold text-center">36.000</td>
                                        <td className="text text-1">36.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold">
                                            Pauza
                                            </td>
                                        <td className="text text-1">
                                            15:00
                                            </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            27
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">20.000</td>
                                        <td className="text text-1 text-bold text-center">40.000</td>
                                        <td className="text text-1">40.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            28
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">25.000</td>
                                        <td className="text text-1 text-bold text-center">50.000</td>
                                        <td className="text text-1">50.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>

                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            29
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">30.000</td>
                                        <td className="text text-1 text-bold text-center">60.000</td>
                                        <td className="text text-1">60.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-7 text-bold">
                                            30
                                            </td>
                                        <td className="text text-1">
                                            20:00
                                            </td>
                                        <td className="text text-1 text-bold text-center">40.000</td>
                                        <td className="text text-1 text-bold text-center">80.000</td>
                                        <td className="text text-1">80.000</td>
                                        {/* <td className="text-left  text text-1"></td> */}
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold">
                                            Pauza
                                            </td>
                                        <td className="text text-1">
                                            15:00
                                            </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className="text text-1 text-bold text-center" colSpan="6" >
                                            <br />
                                                IZMJENE UZ DISKRECIJU TURINIRSKOG DIREKTORA
                                            <br />
                                            <br />
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                            <br />
                        </div>
                    }



                    {this.state.selectedTab == 'Rezultati' &&
                        <div>
                            <div className="padding-sides-medium-2">

                                <br />
                                    Završili smo sa prvim turnirom u LIVE Poker Room-u. Garantirani nagradni fond je bio <span className="no-wrap">30.000 kn</span>. Okrunili smo pobjednika sa pokalom i prvom nagradom od <b className="no-wrap">10.800 kn!</b>
                                <br /><br />
                                    Čestitke Hrvoju!

                                <img className="as-block margin-top margin-bottom" src="https://cdn.supersport.hr/Casino/Images/PokreRoomOpeningEvent/winner.jpg" />


                                <h3 className="v1">Poredak</h3>
                            </div>


                            <table className="table-1 v2 ">
                                <thead>
                                    <tr>
                                        <th className="text-left text text-6" >Plasman</th>
                                        <th className="text-left text text-6" >Ime i prezime</th>
                                        {/* <th className="text-right text text-6"  >Osvojena nagrada</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="horizontal-lines">
                                        <td>1.</td>
                                        <td className=" text-bold">Hrvoje</td>
                                        <td className="text-right text text-7">10.000 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>2.</td>
                                        <td className=" text-bold">Branko</td>
                                        <td className="text-right text text-7">6.000 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>3.</td>
                                        <td className=" text-bold">Tin</td>
                                        <td className="text-right text text-7">4.200 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>4.</td>
                                        <td className=" text-bold">Niko</td>
                                        <td className="text-right text text-7">3.000 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>5.</td>
                                        <td className=" text-bold">Marcel</td>
                                        <td className="text-right text text-7">2.250 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>6.</td>
                                        <td className=" text-bold">Kristijan</td>
                                        <td className="text-right text text-7">1.650 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>7.</td>
                                        <td className=" text-bold">Darko</td>
                                        <td className="text-right text text-7">1.200 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>8.</td>
                                        <td className=" text-bold">Ivan</td>
                                        <td className="text-right text text-7">900 kn</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>9.</td>
                                        <td className=" text-bold">Miljenko</td>
                                        <td className="text-right text text-7">800 kn</td>
                                    </tr>

                                </tbody>
                            </table>

                            <br /><br />
                            <hr></hr>
                        </div>



                    }


                    <div className="text-center"><a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank"
                        href="https://view.officeapps.live.com/op/embed.aspx?src=https://cdn.supersport.hr/Casino/Poker/Pravila/30.05.classicmini.doc"><span>Pravila igre</span> <span className="icon ico-expand-outline"></span></a>

                    </div>


                </div>
                <ObavijestiPoker {...this.props}></ObavijestiPoker>
            </div>
        </div>

    }
};
